// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

/**
 * Rate history: one row per change of a current buy or sell rate, written by a
 * database trigger. Read-only — a rate holds from its rateDate until the next row
 * for the same pair and source.
 */
export default class CurrencyRatesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCurrencyRates';
        this.Server = this.props.context.getState().server.publicCurrencyRates;
        this.MenuDisplayType = 'menu';
        this.disableGlobalEditor = true;
        this.disableAdd = true;
        this.searchFields = ['source.name'];

        const defaultHead = [
            {
                id: 'sourceId',
                label: 'source',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencyRateSources',
                object: 'source',
                show: 'name',
                displayGrid: true,
                disableEditor: true,
                customSort: 'source.name'
            },
            {
                id: 'currency1Id',
                label: 'currency1',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'currency1',
                show: 'code',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'currency2Id',
                label: 'currency2',
                alignRight: false,
                cell: 'Select',
                from: 'publicCurrencies',
                object: 'currency2',
                show: 'code',
                displayGrid: true,
                disableEditor: true
            },
            { id: 'buyRate', label: 'buyRate', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'sellRate', label: 'sellRate', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'rateDate', label: 'rateDate', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
